// src/components/session/SessionLoginOauth.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useLogin from '../../hooks/useLogin';
import { useSession } from '../../contexts/SessionContext';

const SessionLoginOauth: React.FC = () => {
  const { completeProviderLogin, error } = useLogin();
  const { dispatch } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      // fetchProfile: true -> calls /session/me and returns your UserProfile
      const profile = await completeProviderLogin({ fetchProfile: true } as any);
      if (cancelled || !profile) return;

      // 1) update global session
      dispatch({ type: 'LOGIN', payload: { account: profile } });

      // 2) Redirect to profile if it's the first login or go back where the user came from (or home)
      const isFirstLogin = localStorage.getItem("isFirstLogin") === "true";
      const redirect = isFirstLogin ? "/profile" : localStorage.getItem('oauth_redirect') || "/";

      localStorage.removeItem('oauth_redirect');
      localStorage.removeItem('isFirstLogin');

      navigate(redirect, { replace: true });
    })();

    return () => { cancelled = true; };
  }, [completeProviderLogin, dispatch, navigate]);

  if (error) return <div>Login failed: {error}</div>;
  return <div>Signing you in…</div>;
};

export default SessionLoginOauth;
